export const GET_AUTHORS_REQUEST = "GET_AUTHORS_REQUEST";
export const GET_AUTHORS_RESPONSE = "GET_AUTHORS_RESPONSE";
export const DELETE_AUTHORS_REQUEST = "DELETE_AUTHORS_REQUEST";

export const ADD_AUTHOR_REQUEST = "ADD_AUTHOR_REQUEST";
export const ADD_AUTHOR_RESPONSE = "ADD_AUTHOR_RESPONSE";

export const EDIT_AUTHOR_REQUEST = "EDIT_AUTHOR_REQUEST";
export const EDIT_AUTHOR_RESPONSE = "EDIT_AUTHOR_RESPONSE";
